import { useState } from 'react'
import { Box, Stack, TextField, Typography, Button } from '@mui/material'
import BasicModal from '@components/Modal/BasicModal' 
import { useIsMobile } from '@/hooks/Responsive'

export default function CancelDialog({
  open,
  onClose,
  onSubmit,
  defaultValue = '',
  data,
}) {
  const { isMobile } = useIsMobile()
  const [reason, setReason] = useState(defaultValue)

  const handleSubmit = () => {
    if (!reason.trim()) {
      alert('내용을 입력해 주세요.')
      return
    }
    onSubmit?.(reason)
    onClose?.()
  }

  return (
    <BasicModal
      open={open}
      onClose={onClose}
      title="취소사유"
      variant="bottomsheet"
      actions={
        <>
          {!isMobile && (
            <Button variant="outlined" size="medium" color="grey" onClick={onClose}>
              취소
            </Button>
          )}
          <Button variant="contained" size={isMobile ? 'large' : 'medium'} color="primary" onClick={handleSubmit}>
            등록
          </Button>
        </>
      }
    >
      <Box>
        {/* 강좌명 */}
        <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 3 }}>
          <Typography fontWeight={500}>강좌명</Typography>

          <Box
            sx={{
              width: '1px',
              height: '16px',
              bgcolor: 'divider',
              mx: 1,
            }}
          />

          <Typography>{data?.eduLectureName || '-'}</Typography>
        </Stack>

        {/* 내용 입력 */}
        <Stack spacing={1}>
          <Typography
            component="label"
            htmlFor="cancel-reason"
            fontWeight={500}
          >
            내용 <Typography component="span" color="error.main">*</Typography>
          </Typography>
          <TextField
            id="cancel-reason"
            placeholder="취소 사유를 입력해 주세요"
            multiline
            minRows={6}
            fullWidth
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />
        </Stack>
      </Box>
    </BasicModal>
  )
}
